import * as _ from "lodash";

import { FarmEntity, Insights } from "@ctra/api";
import { Optional } from "@ctra/utils";

import { useFarm, useFarmList } from "@farms";

type LatestInsights = {
  insightListQuery: Optional<Record<string, unknown>>;
  insightListName: string;
};

/**
 * List query and list name for latest insights
 */
export const useOnboardingInsights = (farmID?: FarmEntity["id"]): LatestInsights => {
  const {
    farm,
    api: { getFarmName }
  } = useFarm();

  const { farmList, isLoading: isFarmListLoading } = useFarmList();

  /**
   * Make a query for the insight list widget
   * @todo don't add farm info here, that goes one level deeper
   */
  const insightListQuery = isFarmListLoading
    ? void 0
    : {
        orderBy: "endEpoch desc",
        expand: Insights.presets.expandDefaults(),
        filter: {
          ...Insights.queries.ofTypeID(81),
          farmID: farm?.id || { in: _.map(_.map(farmList, "id"), _.toNumber) },
          insightState: { in: Insights.presets.insightStates() }
        }
      };

  /**
   * Set an insight list name, append the farm name or id if available.
   */
  const farmId = farm ? _.camelCase(getFarmName(farm) as string) || farm.id : null;
  const insightListName = _.join(_.compact(["onboardingInsights", farmId]), "-");

  return { insightListQuery, insightListName };
};
